import React from "react";

function Filter({ className }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.9858 5.42354C14.0075 4.9798 9.99212 4.9798 6.01379 5.42354C5.9528 5.43053 5.89481 5.45376 5.84586 5.49081C5.79691 5.52786 5.7588 5.57737 5.7355 5.63417C5.71221 5.69097 5.70459 5.75298 5.71344 5.81373C5.72228 5.87448 5.74727 5.93174 5.78579 5.97954L9.30279 10.3275C10.5626 11.8849 11.2498 13.8274 11.2498 15.8305V18.7195L12.7498 19.8195V15.8295C12.75 13.8268 13.4372 11.8847 14.6968 10.3275L18.2138 5.97954C18.2523 5.93174 18.2773 5.87448 18.2861 5.81373C18.295 5.75298 18.2874 5.69097 18.2641 5.63417C18.2408 5.57737 18.2027 5.52786 18.1537 5.49081C18.1048 5.45376 18.0468 5.43053 17.9858 5.42354ZM5.84779 3.93254C9.93673 3.47561 14.0639 3.47561 18.1528 3.93254C19.5988 4.09454 20.2958 5.79054 19.3808 6.92254L15.8638 11.2705C14.8196 12.5609 14.2499 14.1706 14.2498 15.8305V21.2995C14.2499 21.4382 14.2115 21.5742 14.139 21.6924C14.0664 21.8106 13.9625 21.9064 13.8388 21.9691C13.7151 22.0318 13.5764 22.0589 13.4382 22.0476C13.2999 22.0362 13.1676 21.9866 13.0558 21.9045L10.0558 19.7045C9.96086 19.6348 9.88369 19.5437 9.83053 19.4386C9.77736 19.3335 9.74971 19.2173 9.74979 19.0995V15.8295C9.74979 14.1695 9.17979 12.5605 8.13679 11.2695L4.61979 6.92354C3.70379 5.79154 4.39979 4.09454 5.84779 3.93254Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Filter;
